<div class="page-wide mt-60">
  <div class="d-flex flex-column flex-sm-row  gap-3 gap-xl-5">
    <div class="w-50 w-sm-100 mb-4">
      <div class="pe-md-5">
        <h1 class="fw-bold custom-text">
          Partner with FairBridge Hospitality Systems
        </h1>
        <h5 class="custom-text mt-4 lh-base">
          FairBridge offers best in class options for Branding, Technology, &
          Support Services to hotels across all market segments.
        </h5>
        <p class="mt-xl-5 custom-text">
          Request information on Promotional Licensing Programs for your site by
          completing our Inquiry Form or simply reach out to us directly at
          <a href="mailto:info&#64;fairbridgeinns.com" target="_blank"
            class="text-decoration-none">info&#64;fairbridgeinns.com</a>
          with your property information.
        </p>
        <p class="mt-xl-2 custom-text">
          Upon completing the inquiry form, a Brand Development Specialist will
          contact you within one business day to share available licensing
          opportunities in your area and answer questions about our streamlined
          conversion process.
        </p>
        <div class="mt-xl-5 brand-left">
          <img src="assets/images/brand-development.webp" />
        </div>
      </div>
    </div>
    <div class="w-50 w-sm-100 form-contact">
      <h4 class="custom-text mb-lg-5">Become a FairBridge Member</h4>
      <form class="form" [formGroup]="brandDevelopmentForm" (ngSubmit)="onSubmit()">
        <label for="contact" class="form-label">Contact Information</label>
        <div class="row g-3" formGroupName="contactInformation">
          <!-- First Name -->
          <div class="col-md-6">
            <input formControlName="firstName" type="name" id="firstName" class="form-control" placeholder="First Name*"
              required />
            <small class="text-danger" *ngIf="
                contactInfo.get('firstName')?.touched &&
                contactInfo.get('firstName')?.hasError('required')
              ">
              First name is required.
            </small>
            <small class="text-danger" *ngIf="
                contactInfo.get('firstName')?.touched &&
                contactInfo.get('firstName')?.hasError('minlength')
              ">
              First name must be at least 3 characters.
            </small>
          </div>

          <!-- Last Name -->
          <div class="col-md-6">
            <input type="text" formControlName="lastName" type="name" id="lastName" class="form-control"
              placeholder="Last Name*" required />
            <small class="text-danger" *ngIf="
                contactInfo.get('lastName')?.touched &&
                contactInfo.get('lastName')?.hasError('required')
              ">
              Last name is required.
            </small>
            <small class="text-danger" *ngIf="
                contactInfo.get('lastName')?.touched &&
                contactInfo.get('lastName')?.hasError('minlength')
              ">
              Last name must be at least 2 characters.
            </small>
          </div>

          <!-- Email Address -->
          <div class="col-md-6">
            <input type="email" formControlName="email" id="email" class="form-control" placeholder="Email Address*"
              required />
            <small class="text-danger" *ngIf="
                contactInfo.get('email')?.touched &&
                contactInfo.get('email')?.hasError('required')
              ">
              Email is required.
            </small>
            <small class="text-danger" *ngIf="
                contactInfo.get('email')?.touched &&
                contactInfo.get('email')?.hasError('email')
              ">
              Enter a valid email.
            </small>
          </div>

          <!-- Phone Number -->
          <div class="col-md-6">
            <input formControlName="phone" type="phone" id="phone" class="form-control" placeholder="Phone Number*"
              required />
            <small class="text-danger" *ngIf="
                contactInfo.get('phone')?.touched &&
                contactInfo.get('phone')?.hasError('required')
              ">
              Phone number is required.
            </small>
            <small class="text-danger" *ngIf="
                contactInfo.get('phone')?.touched &&
                contactInfo.get('phone')?.hasError('pattern')
              ">
              Enter a valid 10-digit phone number.
            </small>
          </div>
        </div>

        <div class="row g-3 mt-3">
          <div class="col-md-6">
            <label for="city" class="form-label">City</label>
            <input type="text" id="city" class="form-control" formControlName="city" />

            <small class="text-danger" *ngIf="
                brandDevelopmentForm.get('city')?.touched &&
                brandDevelopmentForm.get('city')?.hasError('required')
              ">
              City is required.
            </small>
          </div>
          <div class="col-md-6">
            <label for="city" class="form-label">State</label>
            <ng-select [items]="states" bindLabel="label" bindValue="value" placeholder="Select State"
              class="form-control" id="state" name="state" [dropdownPosition]="'below'" required
              formControlName="state">
              <!-- @for(state of states; track $index;){
              <option [value]="state">{{ state }}</option>
              } -->
              <small class="text-danger" *ngIf="
                  brandDevelopmentForm.get('state')?.touched &&
                  brandDevelopmentForm.get('state')?.hasError('required')
                ">
                Please select a state.
              </small>
            </ng-select>
          </div>
        </div>

        <div class="row g-3 mt-3">
          <div class="col-md-6">
            <label for="property-name" class="form-label">Current Property Name</label>
            <input type="text" id="property-name" class="form-control" placeholder="Current Property Name"
              formControlName="propertyName" />
            <small class="text-danger" *ngIf="
                brandDevelopmentForm.get('propertyName')?.touched &&
                brandDevelopmentForm.get('propertyName')?.hasError('required')
              ">
              Property name is required.
            </small>
            <small class="text-danger" *ngIf="
                brandDevelopmentForm.get('propertyName')?.touched &&
                brandDevelopmentForm.get('propertyName')?.hasError('minlength')
              ">
              Property name must be at least 3 characters.
            </small>
          </div>
          <div class="col-md-6">
            <label for="room-count" class="form-label">Room Count</label>
            <input type="number" id="room-count" class="form-control" formControlName="roomCount" />
            <small class="text-danger" *ngIf="
                brandDevelopmentForm.get('roomCount')?.touched &&
                brandDevelopmentForm.get('roomCount')?.hasError('required')
              ">
              Room count is required.
            </small>
            <small class="text-danger" *ngIf="
                brandDevelopmentForm.get('roomCount')?.touched &&
                brandDevelopmentForm.get('roomCount')?.hasError('min')
              ">
              Room count must be at least 10.
            </small>
          </div>
        </div>
        <div class="mt-3 d-flex gap-2">
          <label for="property-type" class="form-label">Property Type: </label>
          <input type="radio" id="interior" name="propertyType" value="interior-corridor"
            formControlName="propertyType" />

          <label for="interior-corridor">Interior Corridor</label><br />
          <input type="radio" id="exterior" name="propertyType" value="exterior-corridor"
            formControlName="propertyType" />
          <label for="exterior-corridor">Exterior Corridor</label><br />
        </div>
        <div class="mt-4 d-flex gap-2">
          <label for="property-type" class="form-label">
            Affiliation Type:
          </label>
          <input type="radio" id="independent" name="affiliationType" value="independent"
            formControlName="affiliationType" />
          <label for="independent">Independent</label><br />
          <input type="radio" id="franchise" name="affiliationType" value="franchise"
            formControlName="affiliationType" />
          <label for="franchise">Franchise</label><br />
        </div>
        <div class="mt-4">
          <label for="market-segment" class="form-label">Market Segment</label>

          <ng-select [items]="marketSegment" bindLabel="label" bindValue="value" placeholder="Select Market Segment"
            [dropdownPosition]="'below'" required id="market-segment" name="marketSegment" class="form-control" required
            formControlName="marketSegment"></ng-select>

          <small class="text-danger" *ngIf="
              brandDevelopmentForm.get('marketSegment')?.touched &&
              brandDevelopmentForm.get('marketSegment')?.hasError('required')
            ">
            Please select a market segment.
          </small>
        </div>

        <div class="row g-3 mt-3" formGroupName="callSchedule">
          <label for="contactTime" class="form-label">Best Day and Time to schedule a brief follow up call</label>
          <div class="col-md-6">
            <input type="date" class="form-control" formControlName="date" />
            <small class="text-danger" *ngIf="
                contactSchedule.get('date')?.touched &&
                contactSchedule.get('date')?.hasError('required')
              ">
              Please select a date.
            </small>
          </div>
          <div class="col-md-6">
            <input type="time" class="form-control" formControlName="time" />
          </div>
        </div>

        <div class="form-check mt-3">
          <input type="checkbox" class="form-check-input" id="flexCheckDefault" formControlName="acceptTerms" />
          <small class="small">
            I have read and agreed to the <a routerLink="/privacy-policy" target="_blank">Privacy Policy</a>.
          </small>
          <small class="text-danger" *ngIf="
              brandDevelopmentForm.get('acceptTerms')?.touched &&
              brandDevelopmentForm.get('acceptTerms')?.hasError('requiredTrue')
            ">
            You must accept the terms and conditions.
          </small>
        </div>
        <button [disabled]="brandDevelopmentForm.invalid" type="submit" class="btn btn-primary px-4 mt-4 w-50">
          Submit
        </button>
        <button type="button" class="btn btn-outline-dark mt-4 mx-3 px-3" (click)="clearForm()">
          Clear
        </button>

        <div class="alert alert-success" role="alert" *ngIf="showSuccess" status="success">
          Your message has been sent Successfully!
        </div>
      </form>
    </div>
  </div>
</div>